__webpack_require__.p = "https://assets.worldcubeassociation.org/assets/dad121a/packs/";